import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsOpensslComponent } from './simple-icons-openssl.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsOpensslComponent ],
    exports:      [ SimpleIconsOpensslComponent ],
    bootstrap:    []
})
export class SimpleIconsOpensslModule {}
